(ns com.theplantscape.conversions.core)

;;https://oreillymedia.github.io/Using_SVG/guide/units.html
(def units {:in (/ 1 96) :pc (/ 1 16) :mm (/ 1 3.7795) :cm (/ 1 37.795) :m (/ 1 377.95) :ft (/ 1 1152) :s 0.001})

(defn sqr [n] (* n n))

#_(defn sqrt [n]
    #?(:cljs (Math/sqrt n)
       :clj (Math/sqrt n)))

(defn convert-units [value unit]
  (* (get units unit 1) value))

(defn distance
  [[x1 y1] [x2 y2]]
  (-> (+ (sqr (- x2 x1))
         (sqr (- y2 y1)))
      (Math/sqrt)))

(defn points->middle [[x1 y1] [x2 y2]]
  [(/ (+ x1 x2) 2)
   (/ (+ y1 y2) 2)])

(defn distance-unit
  [xy1 xy2 unit]
  (-> (distance xy1 xy2)
      (convert-units unit)
      (.toFixed 2)))

(defn sgn-distance [[x1 y1] [x2 y2]]
  (if (> 0 (- (+ x1 y1)  (+ x2 y2)))
    (* 1 (distance [x1 y1] [x2 y2]))
    (* -1 (distance [x1 y1] [x2 y2]))))

(defn find-nearest [xy points]
  (->> points
       (map-indexed (fn [idx points] [idx (distance xy points)]))
       (apply min-key second)))

(comment
  (convert-units 10 :ft)
  (sgn-distance [20 20] [10 10])
  (sgn-distance [20 20] [30 30])
  (find-nearest [10 10] [[1 [5 5]] [2 [20 20]]])
)
